import styled from 'styled-components';

import { borderColor, mainColor, sectionColor } from '../../../lib/theme';

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PanelSurface = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
  background: ${sectionColor};
  padding: 8px 12px 10px;
  margin: 4px 0 8px;
`;

// Context sections (Player / Assessment / Age group / Session) flow into as
// many columns as the panel width fits, packing the list horizontally.
export const GroupGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 4px 16px;
  align-items: start;
  margin-top: 4px;
`;

export const VariableGroupBlock = styled.div`
  min-width: 0;
`;

export const VariableRowLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  min-width: 0;
`;

export const TokenChipButton = styled.button`
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 12px;
  line-height: 1.5;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  background: #fff;
  padding: 1px 6px;
  cursor: pointer;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    border-color: ${mainColor};
  }
`;

// Wraps to show the full description rather than truncating; no flex-grow so
// the copy button still hugs the label instead of floating to the far edge.
export const VariableLabel = styled.span`
  font-size: 12px;
  min-width: 0;
  overflow-wrap: break-word;
`;
